/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {setScheduledTransactionPreference} from '../api'

export const useMutationSetScheduledTransactionPreference = createReactQueryMutationHook('setScheduledTransactionPreference', setScheduledTransactionPreference)
